import { minDate } from "../globalVariables";

import { socialNetworksIcons } from "./icons";
import wibes from "./icons/wibes.svg";

import { getDateRange } from "root/js/utils";

import {
  dzen,
  instagram,
  instagram_empty,
  telegram,
  tiktok,
  vkontakte,
  youtube,
} from "root/icons/socialNetworksIcons";
import {
  dDzen,
  dInstagram,
  dTelegram,
  dTikTok,
  dVkontakte,
  dYouTube,
} from "root/icons/socialNetworksIcons/disabled";
//
const instagramDisclaimer =
  "* Принадлежит компании Meta, которая признана экстремистской организацией в России.";
//
// Это часть логики из смежной папки bloggers, потом надо отрефакторить и перенести

const socialNetworksTooltips = {
  instagram: {
    er: "(сумма лайков и комментариев/общее число подписчиков) * 100%",
    err: "(сумма лайков и комментариев/количество просмотров) * 100%",
  },
  vkontakte: {
    er: "(Сумма лайков, комментариев, репостов / количество подписчиков) * 100%",
    err: "(Сумма лайков, комментариев, репостов / количество просмотров) * 100%",
  },
  telegram: {
    er: "(Сумма лайков и комментариев/количество подписчиков) *100%",
    err: "(сумма лайков и комментариев / количество просмотров) *100%",
  },
  tiktok: {
    er: "-",
    err: "-",
  },
  dzen: {
    er: "(сумма лайков и комментариев/количество подписчиков) *100%",
    err: "-",
  },
  youtube: {
    er: "(Сумма лайков и комментариев/количество подписчиков) *100%",
    err: "(сумма лайков и комментариев / количество просмотров) *100%",
  },
  wibes: {
    er: "-",
    err: "-",
  },
};

const socialNetworksLogos = {
  instagram: {
    default: instagram,
    alternative: instagram_empty,
    disabled: dInstagram,
    tooltip: instagramDisclaimer,
  },
  vkontakte: {
    default: vkontakte,
    disabled: dVkontakte,
  },
  telegram: {
    default: telegram,
    disabled: dTelegram,
  },
  tiktok: {
    default: tiktok,
    disabled: dTikTok,
  },
  dzen: {
    default: dzen,
    disabled: dDzen,
  },
  youtube: {
    default: youtube,
    disabled: dYouTube,
  },
  wibes: {
    default: wibes,
    disabled: wibes,
  },
};

// Стили здесь как костыль для карточек блогеров и постов
const socialNetworksData = [
  {
    id: "1",
    name: "tiktok",
    title: "TikTok",
    styles: { backgroundColor: "#000000" },
    icons: socialNetworksIcons.tiktok,
  },
  {
    id: "2",
    name: "vkontakte",
    title: "VK",
    styles: { backgroundColor: "#6563FF" },
    icons: socialNetworksIcons.vkontakte,
  },
  {
    id: "3",
    name: "instagram",
    title: "Instagram*",
    styles: {
      backgroundImage:
        "linear-gradient(white, white),linear-gradient(344deg, #FFDB73 4.42%, #FDAD4E 11.71%, #FB832E 18.09%, #FA7321 21.74%, #F6692F 25.39%, #E84A5A 38.15%, #E03675 48.18%, #DD2F7F 54.56%, #B43D97 66.41%, #4D60D4 92.85%, #4264DB 95.58%)",
      backgroundOrigin: "border-box",
      backgroundClip: "content-box, border-box",
    },
    tooltip: instagramDisclaimer,
    icons: socialNetworksIcons.instagram,
  },
  {
    id: "4",
    name: "telegram",
    title: "Telegram",
    styles: { backgroundColor: "#64A9DC" },
    icons: socialNetworksIcons.telegram,
  },
  {
    id: "5",
    name: "youtube",
    title: "YouTube",
    styles: { backgroundColor: "#E02F2F" },
    icons: socialNetworksIcons.youtube,
  },
  {
    id: "6",
    name: "dzen",
    title: "Dzen",
    styles: { backgroundColor: "#BDC2C7" },
    icons: socialNetworksIcons.dzen,
  },
  {
    id: "7",
    name: "wibes",
    title: "Wibes",
    styles: { backgroundColor: "#CF3AA0" },
    icons: socialNetworksIcons.wibes,
  },
];

const getIconByName = name => {
  switch (name) {
    case "instagram":
      return instagram;
    case "youtube":
      return youtube;
    case "tiktok":
      return tiktok;
    case "telegram":
      return telegram;
    case "vkontakte":
      return vkontakte;
    case "dzen":
      return dzen;
    case "wibes":
      return wibes;
  }
};

export const getDateRangeByPostDate = post_date => {
  try {
    const postDate = new Date(new Date(post_date) - 14 * 24 * 3600 * 1000);
    const { from, to } = getDateRange(30);
    if (postDate < minDate) throw new Error();
    if (postDate > from) return [from, to];
    if (postDate <= from) return [postDate, new Date(Date.parse(postDate) + 30 * 24 * 3600 * 1000)];
  } catch (err) {
    console.error("Некорректная дата поста");
    return null;
  }
};

export {
  socialNetworksTooltips,
  socialNetworksLogos,
  socialNetworksData,
  getIconByName,
  instagramDisclaimer,
};
